/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_X15_DomainInputs */

const en_signin_sso_x15_domain = /** @type {(inputs: Signin_Sso_X15_DomainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That company account belongs to an email domain this workspace does not sign in with. Use your work address.`)
};

/** @type {(inputs: Signin_Sso_X15_DomainInputs) => LocalizedString} */
const ar_signin_sso_x15_domain = en_signin_sso_x15_domain;

/** @type {(inputs: Signin_Sso_X15_DomainInputs) => LocalizedString} */
const he_signin_sso_x15_domain = en_signin_sso_x15_domain;

/** @type {(inputs: Signin_Sso_X15_DomainInputs) => LocalizedString} */
const ur_signin_sso_x15_domain = en_signin_sso_x15_domain;

/** @type {(inputs: Signin_Sso_X15_DomainInputs) => LocalizedString} */
const es_signin_sso_x15_domain = en_signin_sso_x15_domain;

/** @type {(inputs: Signin_Sso_X15_DomainInputs) => LocalizedString} */
const fr_signin_sso_x15_domain = en_signin_sso_x15_domain;

/** @type {(inputs: Signin_Sso_X15_DomainInputs) => LocalizedString} */
const de_signin_sso_x15_domain = en_signin_sso_x15_domain;

/** @type {(inputs: Signin_Sso_X15_DomainInputs) => LocalizedString} */
const pt_signin_sso_x15_domain = en_signin_sso_x15_domain;

/** @type {(inputs: Signin_Sso_X15_DomainInputs) => LocalizedString} */
const hi_signin_sso_x15_domain = en_signin_sso_x15_domain;

/** @type {(inputs: Signin_Sso_X15_DomainInputs) => LocalizedString} */
const bn_signin_sso_x15_domain = en_signin_sso_x15_domain;

/**
* | output |
* | --- |
* | "That company account belongs to an email domain this workspace does not sign in with. Use your work address." |
*
* @param {Signin_Sso_X15_DomainInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_sso_x15_domain = /** @type {((inputs?: Signin_Sso_X15_DomainInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_X15_DomainInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_sso_x15_domain(inputs)
	if (locale === "he") return he_signin_sso_x15_domain(inputs)
	if (locale === "ur") return ur_signin_sso_x15_domain(inputs)
	if (locale === "es") return es_signin_sso_x15_domain(inputs)
	if (locale === "fr") return fr_signin_sso_x15_domain(inputs)
	if (locale === "de") return de_signin_sso_x15_domain(inputs)
	if (locale === "pt") return pt_signin_sso_x15_domain(inputs)
	if (locale === "hi") return hi_signin_sso_x15_domain(inputs)
	if (locale === "bn") return bn_signin_sso_x15_domain(inputs)
	return /** @type {LocalizedString} */ ("That company account belongs to an email domain this workspace does not sign in with. Use your work address.")
});